import React, { Component } from 'react';
import { O2oaPath } from '@/utils/utils';
import Container from "@/components/Container";
import Iframe from '@/components/Iframe';

export default class LeadershipGoOut extends Component {

  render () {
    const IframeDom = Iframe({
      src: `${O2oaPath.pathParams}h5%26page%3DreviewProcess%26processAppId%3D25b72eb5-94ae-40ed-bb71-95098bd7a389%26processId%3Db2ea48f1-7057-4aa8-bee4-dad8019e5b4e`,
    });

    return (<Container breStates>
      <IframeDom />
    </Container>);
  }
}
